<template>
  <svg
    id="svg1"
    version="1.0"
    width="140pt"
    height="140pt"
    viewBox="0 0 140 140"
    preserveAspectRatio="xMidYMid"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="g1"
      transform="matrix(0.06,0,0,-0.06,206,805.03985)"
      fill="#000000"
      stroke="none"
    >
      <path
        id="path2"
        style="fill:#e4e5ec;stroke-width:8.48495"
        d="m -3275.5873,11380.365 c 76.2427,87.491 238.3923,273.69 360.3234,413.673 l 221.7025,254.521 -269.3208,4.007 -269.3143,4.007 -48.5601,23.843 c -50.8106,24.977 -96.6525,71.061 -122.7124,123.421 -11.0064,22.105 -15.3942,50.289 -15.3942,98.842 0,58.438 3.2058,73.265 22.8609,106.724 12.5757,21.438 38.7692,53.295 58.2106,70.859 71.7747,64.851 -13.7847,59.975 1055.9121,59.975 h 958.7987 l 44.7999,-20.235 c 93.9345,-42.478 154.3222,-146.196 142.6948,-245.105 -10.1915,-86.755 -58.9921,-151.471 -148.3783,-196.753 -35.4433,-17.965 -50.1228,-19.1 -303.3349,-23.641 -146.348,-2.672 -266.0884,-7.547 -266.0884,-10.954 0,-6.01 178.3583,-213.246 517.5842,-601.206 90.9957,-104.053 170.6913,-196.485 177.0961,-205.366 11.3871,-15.829 4.7418,-16.163 -305.4588,-16.163 h -317.0994 l -182.4257,209.842 c -274.3901,315.562 -315.5168,360.51 -322.5761,352.897 -3.5396,-4.007 -100.9536,-115.808 -216.4197,-248.778 -115.4729,-133.037 -224.7881,-258.062 -242.9271,-277.896 l -32.9855,-36.065 h -317.8009 -317.8074 z"
      />
      <path
        id="path3"
        style="fill:#e4e5ec;stroke-width:8.48495"
        d="m -2397.3392,12691.707 c -132.2027,55.7 -210.9166,163.96 -218.0826,299.802 -5.6769,107.459 23.5621,179.988 104.8138,260.065 77.8255,76.737 186.2191,109.395 290.6456,87.624 77.6587,-16.163 132.9573,-45.482 180.7295,-95.638 51.5586,-54.231 72.269,-90.562 89.1057,-156.28 38.8426,-151.604 -37.0328,-311.824 -181.2504,-382.883 -49.121,-24.177 -65.5905,-27.784 -137.1049,-30.12 -70.0783,-2.004 -87.8367,0 -128.8567,17.43 z"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'IconDelivery',
  }
</script>
